const headerDropdowns = document.querySelectorAll('.header-dropdown-content')
const navButtons = document.querySelectorAll('.nav-menu__button')
const headerOverlay = document.getElementById('header-overlay')
const navIcons = document.querySelector('.header__icons')

const closeDropdown = (e) => {
  if (
    !document.activeElement.classList.contains('main-nav-link') ||
    e.type === 'click'
  ) {
    headerDropdowns.forEach((headerDropdown) => {
      headerDropdown.classList.add('dropdown-disabled')
    })
    headerOverlay.classList.add('dropdown-disabled')
    document.querySelector('html').classList.remove('no-scroll')
    removeNavEventListeners()
  }
}

const closeDropdownEscapeKey = (e) => {
  if (e.key === 'Escape') closeDropdown()
}

const removeNavEventListeners = () => {
  document.removeEventListener('keydown', closeDropdownEscapeKey)
  navIcons.removeEventListener('mouseover', closeDropdown)
  headerOverlay.removeEventListener('mouseover', closeDropdown)
  headerOverlay.removeEventListener('click', closeDropdown)
}

const addNavEventListeners = () => {
  document.addEventListener('keydown', closeDropdownEscapeKey)
  navIcons.addEventListener('mouseover', closeDropdown)
  headerOverlay.addEventListener('mouseover', closeDropdown)
  headerOverlay.addEventListener('click', closeDropdown)
}

const setFocusForLastEmementLinks = (menuId) => {
  const links = document.querySelectorAll(
    `#HeaderMenu-MenuList-${menuId} .link`
  )
  const lastItem = links[links.length - 1]

  const nextMenuItem = (e) => {
    e.preventDefault()
    if (e.key === 'Tab') {
      let nextLinkItem
      if (document.querySelectorAll('.nav-menu__button a')[menuId]) {
        nextLinkItem = document.querySelectorAll('.nav-menu__button a')[menuId]
      } else {
        nextLinkItem = document.querySelectorAll('.nav-menu__button')[menuId]
      }
      nextLinkItem.focus()
      lastItem.removeEventListener('focusout', nextMenuItem)
    }
  }
  lastItem.addEventListener('keydown', nextMenuItem)
}

const trackTabbing = (e, menuId) => {
  const menu = document.querySelector(`#HeaderMenu-MenuList-${menuId}`)
  const links = menu.querySelectorAll('.link')

  const shiftFocus = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      links[0].focus()
      setFocusForLastEmementLinks(menuId)
      document.removeEventListener('keydown', shiftFocus)
    }
  }
  document.addEventListener('keydown', shiftFocus)
}

navButtons.forEach((button) => {
  const showDropdown = (e) => {
    removeNavEventListeners()
    headerDropdowns.forEach((headerDropdown) => {
      headerDropdown.classList.add('dropdown-disabled')
    })
    e.preventDefault()
    const menuId = button.dataset.menuId
    if (document.getElementById(`HeaderMenu-MenuList-${menuId}`)) {
      document
        .getElementById(`HeaderMenu-MenuList-${menuId}`)
        .classList.remove('dropdown-disabled')
      headerOverlay.classList.remove('dropdown-disabled')
      if (document.height > window.innerHeight) {
        document.querySelector('html').classList.add('no-scroll')
      }
      addNavEventListeners()
      if (e.type === 'focusin') {
        trackTabbing(e, menuId)
      }
    } else {
      closeDropdown()
    }
  }
  button.addEventListener('focusin', showDropdown)
  button.addEventListener('mouseover', showDropdown)
})

// Header Countdown
if (document.querySelector('.header-bar-countdown')) {
  const blackFridayCountdown = () => {
    const now = new Date()
    const doorbusterDate = new Date('2022-11-27T19:00:00')
    const diff = doorbusterDate - now
    const days = Math.floor(diff / 1000 / 60 / 60 / 24)
    const hours = Math.floor(diff / 1000 / 60 / 60) % 24
    const minutes = Math.floor(diff / 1000 / 60) % 60
    const seconds = Math.floor(diff / 1000) % 60
    document.querySelector('.heading-bar .header-bar-countdown').innerHTML = `
            <span class="day">${days}d</span>
            <span class="hour">${hours < 10 ? '0' + hours : hours}h</span>
            <span class="minute">${
              minutes < 10 ? '0' + minutes : minutes
            }m</span>
            <span class="second">${
              seconds < 10 ? '0' + seconds : seconds
            }s</span>
        `
  }
    // setInterval(blackFridayCountdown, 1000)

  const renderTime = (time) => {
    document.querySelector('.heading-bar .header-bar-countdown').innerHTML = `
            <span class="hour">${time.hour}h</span>
            <span class="minute">${time.minute}m</span>
            <span class="second">${time.second}s</span>
        `
  }

  const initializeCountdown = () => {
    const hourExpire = parseInt(
      document.querySelector('.header-bar-countdown').getAttribute('data-hour')
    )

    const startCountdown = () => {
      let end

      const today = new Date(
        new Date().getTime() +
          new Date().getTimezoneOffset() * 60000 +
          3600000 * -6
      )

      if (today.getHours() > hourExpire) {
        end = new Date(
          new Date(today.getDate() + 1).setHours(hourExpire)
        ).getTime()
      } else {
        end = new Date(new Date(today.getDate()).setHours(hourExpire)).getTime()
      }

      let todayTime = today.getTime()
      let distance = end - todayTime

      let hour = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      )
      let minute = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
      let second = Math.floor((distance % (1000 * 60)) / 1000)
      // const second = (tommorrow.getTime() - today.getTime()) / 1000;

      const time = {
        hour: 24 - Math.abs(hour),
        minute: 60 - Math.abs(minute),
        second: 60 - Math.abs(second),
      }

      renderTime(time)
      setTimeout(() => startCountdown(), 1000)
    }

    startCountdown()
  }

  initializeCountdown()
}
